
<div class="titleDiv">
  <h1 mat-dialog-title>Service Interruption Notice</h1>
</div>
<div style="text-align: justify; font-size: medium;">
<mat-dialog-content style="max-height: 800px; overflow-y: auto;" class="mat-typography">
 <p>
    Dear Stakeholders,
</p>

<p>
We wish to inform you that, as of this morning, our service which supports biometric authentication will be <strong>temporarily unavailable</strong>.</p>

<p>
Services affected include:
</p>

<ul>
<li> <strong>Updating Contact Details</strong> (student’s side)</li>
<li> <strong>Duplicate Registration Confirmations</strong></li>
<li> <strong>Banking Verification Edits</strong></li>
<li> <strong>Password Reset</strong></li>
</ul>
<p>
We appreciate your patience and understanding as we work diligently to restore these services.
</p>

<p>
Thank you for your cooperation.
<br>
<strong>NSFAS Management</strong>
</p>
 
</mat-dialog-content>
</div>
<mat-dialog-actions align="end">
  <!-- <button btn-primary mat-dialog-close>Close</button> -->
  <button type="button" mat-dialog-close class="btn btn-primary">Close</button>
</mat-dialog-actions>
